import React from 'react';
import styled from 'styled-components';
import { SectionName, SectionTitle } from '../common/styles';

const Container = styled.div`
  margin: ${props => (props.theme.isMobile ? '67px 0 19px 19px' : '0 auto')};
  padding-bottom: 6px;
  max-width: 1230px;
  width: 85vw;
  display: flex;
  flex-direction: column;
  align-items: start;
`;

export const Timestamp = styled(SectionName)`
  font-size: 12px;
`;

export const Title = styled(SectionTitle)`
  margin: 6px 0 0 0;
  line-height: 40px;
  height: 46px;
  max-width: 795px;
  border-bottom: 1px dashed ${props => props.theme.primaryColor};
  font-size: ${props => (props.theme.isMobile ? 25 : 40)}px;
`;

export const Div = styled.div`
  position: relative;
  max-width: 1180px;
  width: 82vw;
  color: ${props => props.theme.bodyColor};
  font-size: 16px;
  line-height: 25px;
  text-align: left;
`;

export const Headline = styled(Div)`
  font-size: 20px;
  font-weight: ${props => props.theme.fontWeightBold};
  margin-top: 33px;
`;

export const Disclaimer = styled(Title)`
  border-bottom: none;
`;

export default function Content() {
  return (
    <Container>
      {/* eslint-disable max-len */}
      {/* eslint react/jsx-one-expression-per-line: 0 */}
      <Timestamp>Updated 25 Jan 2022</Timestamp>
      <Title>House Rules</Title>
      <Headline>Who can contribute to Livewire?</Headline>
      <Div>
        <p>
          Contributors to Livewire are investment professionals from fund managers and
          wealth management firms. Contributors are typically investment decision-makers,
          including chief investment officers, portfolio managers, analysts and economists.
        </p>
        <p>
          If you are interested in learning more about becoming a Livewire contributor, please
          send us an enquiry <a href="https://www.livewiremarkets.com/company/solutions#get_in_touch">here</a>.
        </p>
      </Div>
      <Headline>Who reads Livewire</Headline>
      <Div>
        <p>
          The Livewire audience is highly engaged with over 280,000 monthly active users
          visiting the website. The audience is made up of Financial Advisers, High Net Worth
          Investors, Self-Managed Super Funds, Family Offices, Wealth Managers,
          Stockbrokers and Retail Investors.
        </p>
      </Div>
      <Headline>How do I publish on Livewire?</Headline>
      <Div>
        <p>
          Livewire is a self-publishing platform. Once approved, Contributors gain access to
          Livewire’s editing tool allowing them to publish directly to the Livewire website.
        </p>
      </Div>
      <Headline>What content can I publish on Livewire?</Headline>
      <Div>
        <p>
          Contributors can engage with our readers by publishing educational insights and
          actionable investment ideas. You can post written articles, video, podcasts and pdf
          reports.
        </p>
        <p>
          Please note <strong>product promotion is not allowed</strong> for contributed content (See Links
          and Promotional below).
        </p>
      </Div>
      <Headline>Use language everyone can understand</Headline>
      <Div>
        <p>
          You can say smart things without using complicated language. We encourage
          Contributors to use language that everyone can understand and to avoid using
          ‘jargon’. If financial terminology / acronyms are required, then we recommend
          providing a brief explainer. If you are using charts to illustrate your point, they are
          made more effective with contextualizing captions.
        </p>
      </Div>
      <Headline>Links and Promotional</Headline>
      <Div>
        <p>
          Product push, promotional content, and links back to product or fund websites are
          not allowed.
        </p>
        <p>
          Livewire has Sponsored Content and Advertising Solutions for firms looking to
          promote specific products / services - to find out more please email us at <a href="mailto:team@livewiremarkets.com">team@livewiremarkets.com</a>
        </p>
      </Div>
      <Headline>Comments</Headline>
      <Div>
        <p>
          Commenting is allowed on all posts on Livewire and presents a valuable opportunity
          to engage with end investors. Livewire’s editors review all reader comments to
          before they are published.
        </p>
        <p>
          We strongly recommend contributors take the time to acknowledge comments and
          to provide responses to any reader questions.
        </p>
      </Div>
      <Headline>9 top tips to get your wires read on Livewire</Headline>
      <Div>
        <p>
          Over the years, we’ve learnt a thing or two about what makes for a good read. So, we
          wanted to share a few tips to help you get more eyeballs across your wires.
        </p>
        <ul>
          <li>100 to 130 words is the ideal length for your introduction.</li>
          <li>Keep headlines short; ideally around 6 words or 65 characters.</li>
          <li>Personal posts get much higher engagement rates than company posts.</li>
          <li>The optimal time to post is between 7am and 11am.</li>
          <li>Break up your post using subheads, paragraph breaks, bullets and images.</li>
          <li>Use captions with your charts to help your readers with context.</li>
          <li>Include links in your article to other wires you’ve posted.</li>
          <li>Ask yourself: “Will my article help readers become better investors?”</li>
          <li>Use a conclusion to highlight your actionable insight.</li>
        </ul>
      </Div>
    </Container>
  );
}
